import { Fingerprint, Globe, Info, Lock, Shield, Timer, User } from 'lucide-react';
import {
  AvisosDeAjustes,
  BannerDeActivacion,
  BarraDeGuardado,
  Campo,
  CargandoAjustes,
  EntradaDeContrasena,
  FalloDeAjustes,
  Resumen,
  Seccion,
  entrada,
  useAjustes,
} from './ajustes';
import { PruebaDeIdentidad } from './PruebaDeIdentidad';

export function PaginaDinardap() {
  const ajustes = useAjustes(['dinardap']);

  if (ajustes.cargando) {
    return <CargandoAjustes bloques={3} />;
  }
  if (ajustes.fallo) {
    return <FalloDeAjustes causa={ajustes.fallo} />;
  }

  const activo = ajustes.booleano('dinardap_activo');
  const url = ajustes.texto('dinardap_url');
  const usuario = ajustes.texto('dinardap_usuario');
  const hayClave = ajustes.meta('dinardap_clave')?.tieneValor ?? false;

  return (
    <div className="grid gap-6">
      <AvisosDeAjustes ajustes={ajustes} />

      <BannerDeActivacion
        icono={Fingerprint}
        activo={activo}
        titulo={activo ? 'Consulta de identidad activada' : 'Consulta de identidad desactivada'}
        descripcion={
          activo
            ? 'Al escribir una cédula o un RUC se traen los datos del titular'
            : 'Los datos del cliente se escriben a mano'
        }
        alCambiar={() => ajustes.alternar('dinardap_activo', activo)}
      />

      <div className="flex gap-3 rounded-xl border border-blue-200 bg-blue-50 p-4">
        <Info className="mt-0.5 size-4 shrink-0 text-blue-600" aria-hidden />
        <p className="text-xs uppercase text-blue-800">
          <span className="font-semibold uppercase">El servicio es de un tercero.</span> Las
          credenciales las entrega la institución que tiene el convenio de interoperabilidad.
          Mientras no estén, la consulta queda desactivada y no bloquea nada: los datos se
          escriben a mano.
        </p>
      </div>

      <Seccion icono={Fingerprint} color="indigo" titulo="Servicio de consulta">
        <div className="grid gap-4">
          <Campo
            etiqueta="Dirección del servicio"
            icono={Globe}
            ayuda="Hasta antes de la identificación: el sistema le añade /0501234567"
          >
            <input
              value={url}
              onChange={(e) => ajustes.editar('dinardap_url', e.target.value)}
              placeholder="https://servidor.gob.ec/services/api/dinardap/consulta"
              className={`${entrada} pl-10 font-mono text-xs`}
            />
          </Campo>

          <div className="grid gap-4 sm:grid-cols-2">
            <Campo etiqueta="Usuario" icono={User}>
              <input
                value={usuario}
                onChange={(e) => ajustes.editar('dinardap_usuario', e.target.value)}
                placeholder="Usuario del convenio"
                className={`${entrada} pl-10`}
              />
            </Campo>

            <Campo
              etiqueta="Clave"
              icono={Lock}
              ayuda={
                hayClave
                  ? 'Hay una guardada · déjela vacía para no cambiarla'
                  : 'Se guarda cifrada en la base de datos'
              }
            >
              <EntradaDeContrasena ajustes={ajustes} clave="dinardap_clave" />
            </Campo>
          </div>

          <Campo
            etiqueta="Cuánto se espera la respuesta"
            icono={Timer}
            ayuda="En milisegundos. Hay una persona esperando en la ventanilla: si tarda más que esto, es más rápido escribir los datos a mano"
          >
            <input
              type="number"
              min={1000}
              step={500}
              value={ajustes.texto('dinardap_espera_ms')}
              onChange={(e) => ajustes.editar('dinardap_espera_ms', e.target.value)}
              placeholder="8000"
              className={`${entrada} importe pl-10`}
            />
          </Campo>
        </div>
      </Seccion>

      <PruebaDeIdentidad />

      <Seccion icono={Shield} color="marca" titulo="Estado de la configuración">
        <Resumen
          puntos={[
            {
              etiqueta: 'Servicio',
              valor: activo ? 'Activado' : 'Desactivado',
              listo: activo,
            },
            { etiqueta: 'Dirección', valor: url || 'Sin configurar', listo: Boolean(url) },
            { etiqueta: 'Usuario', valor: usuario || 'Sin configurar', listo: Boolean(usuario) },
            { etiqueta: 'Clave', valor: hayClave ? 'Guardada' : 'Sin configurar', listo: hayClave },
          ]}
        />
      </Seccion>

      <BarraDeGuardado ajustes={ajustes} />
    </div>
  );
}
